angular
        .module('parentLevelOneCarousel.components', [])
        .component('parentLevelOneCarousel', {
            templateUrl: 'ng/components/parentLevelOneCarousel/parentLevelOneCarousel.html',
            bindings: {
                father: '=',
                value: '<',
                height: '='
            },
            controllerAs: 'parentLevelOneCarouselCtrl',
            controller: function ($scope, $translate) {
            	$scope.selectParentLevel = $scope.$parent.selectParentLevel;
            	$scope.createNewProduct = $scope.$parent.createNewProduct;
                this.$onInit = function () {  
                	customCarouselMenu(); 
                    console.log(this);
                }

                $scope.dataHeight = '20';
                if($(window).height()<=600 && $(window).width()<=1025){
                    $scope.dataHeight = '30';
                }
               
            } 
        });